import { localeTag } from '@/contexts/LanguageContext';
// Booking formatting helpers (Iter 190).

export const toLocalISO = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const formatTime12 = (hhmm) => {
  if (!hhmm) return '';
  const [h, m] = hhmm.split(':').map(Number);
  // Formato horario del idioma activo (en-US «3:30 PM» · es-US «3:30 p.m.» · pt/fr «15:30»). 24:00 = medianoche (fin de cita).
  const d = new Date(2000, 0, 1, h === 24 ? 0 : h, m || 0);
  try {
    return d.toLocaleTimeString(localeTag(), { hour: 'numeric', minute: '2-digit' }).replace(/\u202f/g, ' ');
  } catch {
    const suffix = h >= 12 && h < 24 ? 'PM' : 'AM';
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    return `${hour12}:${String(m).padStart(2, '0')} ${suffix}`;
  }
};

export const formatDuration = (mins) => {
  const v = Number(mins) || 0;
  if (v < 60) return `${v} min`;
  const h = Math.floor(v / 60);
  const rest = v % 60;
  return rest === 0 ? `${h} h` : `${h} h ${rest} min`;
};

export const addMinutes = (hhmm, mins) => {
  const [h, m] = hhmm.split(':').map(Number);
  const total = h * 60 + m + Number(mins || 0);
  return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
};

// "jue, 9 de jul" — short Spanish date from YYYY-MM-DD (local, no TZ shift).
export const formatDateShortEs = (iso) => {
  if (!iso) return '';
  const [y, mo, da] = iso.split('-').map(Number);
  const d = new Date(y, mo - 1, da);
  return d.toLocaleDateString(localeTag(), { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '');
};

export const formatDateLongEs = (iso) => {
  if (!iso) return '';
  const [y, mo, da] = iso.split('-').map(Number);
  const d = new Date(y, mo - 1, da);
  return d.toLocaleDateString(localeTag(), { weekday: 'long', day: 'numeric', month: 'long' });
};
